import React, { useEffect, useState, useRef, useCallback } from 'react';
import {
  Table,
  Button,
  Dialog,
  Input,
  Form,
  DatePicker,
  CascaderSelect,
  Message,
  Tag,
  Select,
  Pagination,
} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import 'antd/dist/antd.css';
import BarcodeReader from 'react-barcode-reader';
import Swal from 'sweetalert2';
import Webcam from 'react-webcam';
import { element } from 'prop-types';

const VisitorAppointmentRegistrationList = (props) => {
  const Option = Select.Option;
  const currentDate = moment();
  const localeData = currentDate.clone().localeData(); //currentDate

  const guestFace = client.service('guestFace');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const cardManagement = client.service('cardManagement');
  // const residentScanType = client.service('residentScanType');
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [visitorAppointmentArr, setVisitorAppointmentArr] = useState([]);
  // console.log(visitorAppointmentArr)
  const [reservationTimeStart, setReservationTimeStart] = useState('');
  const [reservationTimeEnd, setReservationTimeEnd] = useState('');
  const [visitorsName, setVisitorsName] = useState('');
  const [visitorsPhone, setVisitorsPhone] = useState('');
  const [householdNumber, setHouseholdNumber] = useState(''); //戶號
  const [intervieweeName, setIntervieweeName] = useState('');
  const [intervieweeRemarks, setIntervieweeRemarks] = useState('');
  // const [appointmentCode, setAppointmentCode] = useState('');
  const [visitingReason, setVisitingReason] = useState('');
  const [peopleNumber, setPeopleNumber] = useState(1);
  const [takeCardStatus, setTakeCardStatus] = useState('未領卡'); //取卡狀態
  const [visitorsStatus, setVisitorsStatus] = useState('預約中'); //訪客狀態
  const [takeCardLost, setTakeCardLost] = useState('否'); //訪客卡遺失
  const [searchVisitorsCardNumber, setSearchVisitorsCardNumber] = useState('');
  const [cardStatus, setCardStatus] = useState('');

  const [addVisitorDialog, setAddVisitorDialog] = useState(false);
  const [editVisitorDialog, setEditVisitorDialog] = useState(false);
  const [takeCardDialog, setTakeCardDialog] = useState(false);
  const [cancleDialog, setCancleDialog] = useState(false);
  const [leaveDialog, setLeaveDialog] = useState(false);
  const [editVisitorIndex, setEditVisitorIndex] = useState('');
  const [takeCardIndex, setTakeCardIndex] = useState('');
  const [cancleIndex, setCancleIndex] = useState('');
  const [leaveIndex, setLeaveIndex] = useState('');

  //take the card
  const [cardArr, setCardArr] = useState([]);
  const [cardAllArr, setCardAllArr] = useState([]);
  // console.log(cardAllArr)
  const [cardNumber, setCardNumber] = useState('');
  const [scanCardDialog, setScanCardDialog] = useState(false);

  //webcam
  const [webcamDialog, setWebcamDialog] = useState(false);
  const [webcamEditDialog, setWebcamEditDialog] = useState(false);

  //visitorCardLost
  const [cardLostDialog, setCardLostDialog] = useState(false);
  const [cardLostDetailDialog, setCardLostDetailDialog] = useState(false);
  const [cardLostArr, setCardLostArr] = useState([]);
  const [lostVisitorsName, setLostVisitorsName] = useState('');
  const [lostVisitorsPhone, setLostVisitorsPhone] = useState('');
  const [lostHouseholdNumber, setLostHouseholdNumber] = useState('');
  const [lostIntervieweeName, setLostIntervieweeName] = useState('');
  const [lostVisitingReason, setLostVisitingReason] = useState('');
  const [visitorData, setVisitorData] = useState([]);
  const [visitorDataStatus, setVisitorDataStatus] = useState(false);

  //visitorLeave
  const [visitorLeaveDialog, setVisitorLeaveDialog] = useState(false);
  const [visitorLeaveDetialDialog, setVisitorLeaveDetialDialog] = useState(
    false
  );
  const [visitorLeaveArr, setVisitorLeaveArr] = useState([]);
  const [leaveArr, setLeaveArr] = useState([]);
  const [visitorLeaveData, setVisitorLeaveData] = useState('');
  const [leaveCardNumber, setLeaveCardNumber] = useState('');
  // console.log(visitorLeaveArr)

  //登記
  const [residentName, setResidentName] = useState('');
  //residentAccountNumbers
  async function funFindResident(para) {
    const result = await residentAccountNumbers.find({ query: para });
    return result && result.data ? result.data : [];
  }

  function householdNumberSort(a, b) {
    return a.building > b.building
      ? 1
      : -1 && parseInt(a.floor) > parseInt(b.floor)
      ? 1
      : -1 && parseInt(a.floorChild) > parseInt(b.floorChild)
      ? 1
      : -1;
  }

  function serverResidentDataUpdate() {
    funFindResident({}).then((result) => {
      setResidentAccountNumbersArr(result.sort(householdNumberSort));
    });
  }
  useEffect(() => {
    serverResidentDataUpdate();
  }, []);

  //visitor
  async function funFindVisitor(para) {
    const result = await guestFace.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funCreateVisitor(obj) {
    await guestFace.create(obj);
  }
  async function funUpdateVisitor(id, obj) {
    await guestFace.patch(id, obj);
  }
  async function funRemoveVisitor(id) {
    await guestFace.remove(id);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  function serverVisitorDataUpdate() {
    funFindVisitor({}).then((result) => {
      setVisitorAppointmentArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverVisitorDataUpdate();
  }, []);

  //visitorLeave
  async function funFindVisitorLeave() {
    const result = await guestFace.find({
      query: {
        visitorsStatus: '進已入場場',
        cardNumber: visitorLeaveData || leaveCardNumber,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateVisitorLeave(id, obj) {
    await guestFace.update(id, obj);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  function serverVisitorLeaveDataUpdate() {
    funFindVisitorLeave().then((result) => {
      setVisitorLeaveArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverVisitorLeaveDataUpdate();
  }, [visitorLeaveData, leaveCardNumber]);

  //Leave
  async function funFindLeave() {
    const result = await guestFace.find({
      query: {
        visitorsStatus: '已入場',
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateLeave(id, obj) {
    await guestFace.update(id, obj);
  }

  function ordersort(a, b) {
    return a.order < b.order ? 1 : -1;
  }
  function serverLeaveDataUpdate() {
    funFindLeave().then((result) => {
      setLeaveArr(result.sort(ordersort));
    });
  }
  useEffect(() => {
    serverLeaveDataUpdate();
  }, []);

  //cardManagement single data
  async function funFindCard() {
    const result = await cardManagement.find({
      query: {
        cardNumber: cardNumber || visitorLeaveData || leaveCardNumber,
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCard(id, obj) {
    await cardManagement.update(id, obj);
  }

  function serverCardDataUpdate() {
    funFindCard().then((result) => {
      setCardArr(result);
    });
  }
  useEffect(() => {
    serverCardDataUpdate();
  }, [cardNumber, visitorLeaveData, leaveCardNumber]);

  //cardManagement All Data
  async function funFindCardAll(para) {
    const result = await cardManagement.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCardAll(id, obj) {
    await cardManagement.update(id, obj);
  }

  function serverCardAllDataUpdate() {
    funFindCardAll({}).then((result) => {
      setCardAllArr(result);
    });
  }
  useEffect(() => {
    serverCardAllDataUpdate();
  }, []);

  //residentScanType 住戶點數資料Table
  const [selectHouseholdsArr, setSelectHouseholdsArr] = useState([]);
  // async function funFindHouseholds() {
  //   const result = await residentScanType.find({
  //     query: {
  //       householdNumber: householdNumber || lostHouseholdNumber,
  //     },
  //   });
  //   return result && result.data ? result.data : [];
  // }

  // async function funUpdateHouseholds(id, obj) {
  //   await residentScanType.update(id, obj);
  // }
  // function updatedTimeSort(a, b) {
  //   return a.updatedTime < b.updatedTime ? 1 : -1;
  // }
  // function serverDataUpdateHouseholds() {
  //   funFindHouseholds().then((result) => {
  //     setSelectHouseholdsArr(result.sort(updatedTimeSort));
  //   });
  // }
  // useEffect(() => {
  //   serverDataUpdateHouseholds();
  // }, [householdNumber, lostHouseholdNumber]);
  const userNmae = selectHouseholdsArr.map((item) => item.userName).join('');
  // console.log(userNmae)

  //cardLost
  async function funFindCardLost() {
    const result = await guestFace.find({
      query: {
        takeCardStatus: '已領卡',
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCardLost(id, obj) {
    await guestFace.update(id, obj);
  }

  function serverCardLostDataUpdate() {
    funFindCardLost().then((result) => {
      setCardLostArr(result);
    });
  }
  useEffect(() => {
    serverCardLostDataUpdate();
  }, []);

  //cardLost
  async function funFindCardLost() {
    const result = await guestFace.find({
      query: {
        visitorsStatus: '已入場',
      },
    });
    return result && result.data ? result.data : [];
  }
  async function funUpdateCardLost(id, obj) {
    await guestFace.update(id, obj);
  }

  function serverCardLostDataUpdate() {
    funFindCardLost().then((result) => {
      setCardLostArr(result);
    });
  }
  useEffect(() => {
    serverCardLostDataUpdate();
  }, []);

  const removeItem = async () => {
    const result = await funFindVisitor({});
    const items = result.sort(ordersort);
    for (let i = 0; i < items.length; i++) {
      items[i].order = items.length - i - 1;
      await funUpdateVisitor(items[i]._id, items[i]);
    }
    setVisitorAppointmentArr(items.sort(ordersort));
  };
  const dataSource = [];

  for (let i = 0; i < residentAccountNumbersArr.length; i++) {
    //第一層
    let building = residentAccountNumbersArr[i].building;
    let objBuilding = dataSource.find((item) => item.label === building);
    if (!objBuilding) {
      objBuilding = {
        value: `${building}`,
        label: `${building}`,
        children: [],
      };
      dataSource.push(objBuilding);
    }
    //第二層
    let floor = residentAccountNumbersArr[i].floor;
    let objFloor = objBuilding.children.find((item) => item.label === floor);
    if (!objFloor) {
      objFloor = {
        value: `${building}-${floor}`,
        label: `${floor}`,
        children: [],
      };
      objBuilding.children.push(objFloor);
    }

    //第三層
    let floorChild = residentAccountNumbersArr[i].floorChild;
    let objFloorChild = dataSource.find((item) => item.label === floorChild);
    if (!objFloorChild) {
      objFloorChild = {
        value: `${building}-${floor}-${floorChild}`,
        label: `${floorChild}`,
      };
      objFloor.children.push(objFloorChild);
    }
    // console.log(`==${i}th dataSource:`,dataSource)
  }

  function makeid(length) {
    let result = '';
    let characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  //今日進場的訪客
  let sCurrentDate = moment(currentDate).format('YYYYMMDD');
  let visitorAdmissionTime = visitorAppointmentArr.filter(
    (x) => moment(x.admissionTime).format('YYYYMMDD') === sCurrentDate
  );
  let visitorLeaveTime = visitorAppointmentArr.filter(
    (x) => moment(x.leaveTime).format('YYYYMMDD') === sCurrentDate
  );

  let visitorFindEnter = visitorAdmissionTime.filter(
    (x) => x.visitorsStatus === '已入場'
  );
  let visitorFindLeave = visitorLeaveTime.filter(
    (x) => x.visitorsStatus === '已離場'
  );

  //訪客狀態table
  let visitorApproachStatusArr = visitorAppointmentArr;
  visitorApproachStatusArr = visitorAppointmentArr.filter(
    (x) => x.visitorsStatus === '已入場'
  );
  let visitorAppointmentStatusArr = visitorAppointmentArr;
  visitorAppointmentStatusArr = visitorAppointmentArr.filter(
    (x) => x.visitorsStatus === '預約中'
  );
  let visitorLeaveStatusArr = visitorAppointmentArr;
  visitorLeaveStatusArr = visitorAppointmentArr.filter(
    (x) => x.visitorsStatus === '已離場'
  );
  // console.log(statusVisitorAppointmentArr)

  //訪客卡號搜尋
  let serachVisitorApproachArr = visitorApproachStatusArr;
  serachVisitorApproachArr = visitorApproachStatusArr.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let serachVisitorAppointmentArr = visitorAppointmentStatusArr;
  serachVisitorAppointmentArr = visitorAppointmentStatusArr.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );
  let serachVisitorLeaveArr = visitorLeaveStatusArr;
  serachVisitorLeaveArr = visitorLeaveStatusArr.filter(
    (x) => x.cardNumber === searchVisitorsCardNumber
  );

  const webcamRef = useRef(null);
  const [visitorPhoto, setVisitorPhoto] = useState(null);

  const [devices, setDevices] = useState([]);
  // console.log(devices)
  const [devicesVal, setDevicesVal] = useState('');
  let foundDevicesArr = [];
  let foundDevicesResult = devices.find(({ label }) => label === devicesVal);
  foundDevicesArr.push(foundDevicesResult);

  // console.log(foundDevicesArr)

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setVisitorPhoto(imageSrc);
  }, [webcamRef, setVisitorPhoto]);
  // console.log(visitorPhoto)

  async function getWebcam() {
    await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    let devices = await navigator.mediaDevices.enumerateDevices();
    setDevices(devices.filter(({ kind }) => kind === 'videoinput'));
  }
  //顯示所有webcam

  // const handleDevices = useCallback(
  //   mediaDevices =>
  //     setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
  //   [setDevices]
  // );

  // useEffect(
  //   () => {
  //     navigator.mediaDevices.enumerateDevices().then(handleDevices).catch(err => console.warn(err));
  //   },
  //   [handleDevices]
  // );

  //分頁
  // const [pagination, setPagination] = useState({
  //   showPageNumberAudits: [],
  //   allAudits: [],
  //   currentPage: 1
  // });

  // const pageSize = visitorAppointmentStatusArr.length;
  // const pageNumberOnChange = (page) => {
  //   let startNum = page > 0 ? (page - 1) * pageSize : 0;
  //   let tempDisplayAudits = pagination.allAudits.slice(startNum, startNum + pageSize);
  //   setPagination(
  //     {
  //       showPageNumberAudits: allAudits,
  //       currentPage: page
  //     }
  //   );
  //   }
  return (
    <>
      <div className={styles.searchVisitorsCardBox}>
        <div>
          <Button
            className={styles.buttonAdd}
            onClick={() => {
              setAddVisitorDialog(true);
            }}
          >
            訪客登記
          </Button>
          <Button
            className={styles.buttonLost}
            onClick={() => {
              setCardLostDialog(true);
              serverCardLostDataUpdate();
            }}
          >
            訪客卡遺失
          </Button>
          <Button
            className={styles.buttonLost}
            onClick={() => {
              serverCardAllDataUpdate();
              setVisitorLeaveDialog(true);
              setLeaveCardNumber('');
            }}
          >
            訪客離開
          </Button>
        </div>
        <div>
          <h2>快速搜尋訪客卡號</h2>
          <Input
            placeholder="請輸入訪客卡號"
            onChange={(value) => {
              setSearchVisitorsCardNumber(value);
            }}
          />
        </div>
      </div>
      {/* 訪客離開 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorLeaveDialog}
        footer={false}
        onClose={() => {
          setVisitorLeaveDialog(false);
        }}
      >
        <div>
          <BarcodeReader
            onScan={(data) => {
              let foundData = cardAllArr.find(
                (element) => element.cardNumber === data
              );
              try {
                if (foundData.cardStatus === '未使用') {
                  Message.error('查無此卡片');
                } else {
                  setVisitorLeaveData(data);
                  setVisitorLeaveDialog(false);
                  setVisitorLeaveDetialDialog(true);
                }
              } catch (e) {
                // console.log(e)
                Message.error('查無此卡片');
              }
            }}
            onError={(err) => {
              console.error(err);
            }}
          />

          <Input
            placeholder="自行輸入卡片編號 Enter確認"
            value={leaveCardNumber}
            onChange={(value) => {
              setLeaveCardNumber(value);
            }}
            onPressEnter={() => {
              serverVisitorLeaveDataUpdate();

              try {
                if (visitorLeaveArr[0].cardNumber === leaveCardNumber) {
                  setVisitorLeaveDialog(false);
                  setVisitorLeaveDetialDialog(true);
                } else {
                  setVisitorLeaveDialog(false);
                }
              } catch {
                Message.error('無此卡號');
              }
            }}
          ></Input>

          <br />
          <br />
          <img
            src="https://i.ibb.co/h8yWyPd/image0.jpg"
            alt="cardImg"
            type="cover"
            width={400}
            height={300}
          ></img>

          <h1>請掃描卡片...</h1>
        </div>
      </Dialog>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={visitorLeaveDetialDialog}
        footerActions={['ok']}
        onOk={() => {
          let cardItem = cardArr[0];
          cardItem.cardStatus = '未使用';

          let item = visitorLeaveArr[0];
          item.takeCardStatus = '已還卡';
          item.visitorsStatus = '已離場';
          item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          funUpdateVisitor(item._id, item).then(() => {
            serverVisitorDataUpdate();
            setVisitorLeaveDetialDialog(false);
          });

          funUpdateCard(cardItem._id, cardItem).then(() => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: '離開成功',
              showConfirmButton: false,
              timer: 1500,
            });
            serverCardDataUpdate();
            setVisitorLeaveDetialDialog(false);
          });
        }}
        onClose={() => {
          setVisitorLeaveDetialDialog(false);
        }}
      >
        {visitorLeaveArr.map((item, index) => {
          return (
            <div key={index}>
              <h2>確認以下離開訪客資訊</h2>
              <Form.Item label="訪客卡號">{item.cardNumber}</Form.Item>
              <Form.Item label="訪客姓名">{item.visitorsName}</Form.Item>
              <Form.Item label="訪客電話">{item.visitorsPhone}</Form.Item>
              <Form.Item label="受訪人戶號">{item.householdNumber}</Form.Item>
              <Form.Item label="受訪人姓名">
                {item.householdNumberName || item.intervieweeName}
              </Form.Item>
              <Form.Item label="拜訪原因">{item.visitingReason}</Form.Item>
            </div>
          );
        })}
      </Dialog>

      {/* 訪客卡遺失 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={cardLostDialog}
        footerActions={['ok']}
        onOk={() => {
          if (lostVisitorsName && lostVisitorsPhone && lostHouseholdNumber) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsName === lostVisitorsName &&
                x.visitorsPhone === lostVisitorsPhone &&
                x.householdNumber === lostHouseholdNumber
            );
            setVisitorData(serachVisitorDataAll);
          } else if (
            lostVisitorsName &&
            lostVisitorsPhone &&
            lostIntervieweeName
          ) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsName === lostVisitorsName &&
                x.visitorsPhone === lostVisitorsPhone &&
                x.intervieweeName === lostIntervieweeName
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsName && lostVisitorsPhone) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsName === lostVisitorsName &&
                x.visitorsPhone === lostVisitorsPhone
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsName && lostHouseholdNumber) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsName === lostVisitorsName &&
                x.householdNumber === lostHouseholdNumber
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsName && lostIntervieweeName) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsName === lostVisitorsName &&
                x.intervieweeName === lostIntervieweeName
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsPhone && lostHouseholdNumber) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsPhone === lostVisitorsPhone &&
                x.householdNumber === lostHouseholdNumber
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsPhone && lostIntervieweeName) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) =>
                x.visitorsPhone === lostVisitorsPhone &&
                x.intervieweeName === lostIntervieweeName
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsName) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) => x.visitorsName === lostVisitorsName
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostVisitorsPhone) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) => x.visitorsPhone === lostVisitorsPhone
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostHouseholdNumber) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) => x.householdNumber === lostHouseholdNumber
            );
            setVisitorData(serachVisitorDataAll);
          } else if (lostIntervieweeName) {
            let serachVisitorDataAll = cardLostArr.filter(
              (x) => x.intervieweeName === lostIntervieweeName
            );
            setVisitorData(serachVisitorDataAll);
          }
          setCardLostDialog(false);
          setCardLostDetailDialog(true);
          setLostVisitorsName('');
          setLostVisitorsPhone('');
          setLostHouseholdNumber('');
          setLostIntervieweeName('');
        }}
        onCancel={() => {
          setCardLostDialog(false);
        }}
        onClose={() => {
          setCardLostDialog(false);
        }}
      >
        <h2>訪客卡資料查詢</h2>
        <Form.Item label="訪客姓名">
          <Input
            name="visitorsName"
            placeholder="請輸入姓名"
            onChange={(value) => {
              setLostVisitorsName(value);
            }}
          />
        </Form.Item>
        <Form.Item label="訪客電話">
          <Input
            name="Phone"
            placeholder="請輸入電話號碼"
            onChange={(value) => {
              setLostVisitorsPhone(value);
            }}
          />
        </Form.Item>
        <Form.Item label="受訪人戶號">
          <div className={styles.householdNumberBox}>
            <CascaderSelect
              hasClear={true}
              disabled={lostIntervieweeName ? true : false}
              placeholder="請選擇戶號"
              dataSource={dataSource}
              onChange={(value) => {
                // console.log(value)

                residentAccountNumbers
                  .find({ query: { householdNumber: value } })
                  .then((res) => {
                    console.log(
                      '==residentAccountNumbers find householdNumber success:',
                      res.data[0].userName
                    );
                    setHouseholdNumber(value);
                    setResidentName(res.data[0].userName);
                  })
                  .catch((error) => {
                    console.log(
                      '==residentAccountNumbers find householdNumber:',
                      error
                    );
                  });
              }}
            ></CascaderSelect>
            <h3>{userNmae}</h3>
          </div>
        </Form.Item>
        <Form.Item label="受訪人姓名">
          <Input
            disabled={residentName ? true : false}
            name="intervieweeName"
            placeholder="請輸入姓名"
            onChange={(value) => {
              setLostIntervieweeName(value);
            }}
          />
        </Form.Item>
      </Dialog>
      <Dialog
        hasMask
        className={styles.dialog}
        visible={cardLostDetailDialog}
        footerActions={['ok']}
        onOk={() => {
          try {
            let item = visitorData[0];
            item.takeCardLost = '是';
            item.takeCardStatus = '遺失';
            item.visitorsStatus = '已離場';
            item.leaveTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
            funUpdateVisitor(item._id, item).then(() => {
              serverVisitorDataUpdate();
            });
            setCardLostDetailDialog(false);
          } catch (e) {
            setCardLostDetailDialog(false);
          }
        }}
        onClose={() => {
          setCardLostDetailDialog(false);
        }}
      >
        {visitorData.length > 0 ? (
          visitorData.map((item, index) => {
            return (
              <div key={index}>
                <h2>確定卡號為:{item.cardNumber}已遺失?</h2>
                <p>訪客姓名:{item.visitorsName}</p>
                <p>拜訪戶號:{item.householdNumber}</p>
                <p>受訪人:{item.intervieweeName || item.residentName}</p>
                <p>拜訪原因:{item.visitingReason}</p>
              </div>
            );
          })
        ) : (
          <h1>查無此卡片</h1>
        )}
      </Dialog>
      {/* 訪客登記 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={addVisitorDialog}
        onOk={() => {
          setReservationTimeStart('');
          setReservationTimeEnd('');
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setIntervieweeName('');
          setIntervieweeRemarks('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setAddVisitorDialog(false),
            funCreateVisitor({
              createdTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              updatedTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              order: visitorAppointmentArr.length,
              reservationTimeStart: reservationTimeStart,
              reservationTimeEnd: reservationTimeEnd,
              visitorsName: visitorsName,
              householdNumber: householdNumber,
              intervieweeName: intervieweeName,
              residentName: residentName,
              visitorsPhone: visitorsPhone,
              intervieweeRemarks: intervieweeRemarks,
              visitingReason: visitingReason,
              peopleNumber: peopleNumber,
              takeCardStatus: takeCardStatus,
              appointmentCode: makeid(8),
              visitorsStatus: visitorsStatus,
              visitorPhoto: visitorPhoto,
              takeCardLost: takeCardLost,
            }).then(() => {
              serverVisitorDataUpdate();
            });
        }}
        onCancel={() => {
          setReservationTimeStart('');
          setReservationTimeEnd('');
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setIntervieweeName('');
          setIntervieweeRemarks('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setAddVisitorDialog(false);
        }}
        onClose={() => {
          setReservationTimeStart('');
          setReservationTimeEnd('');
          setVisitorsName('');
          setVisitorsPhone('');
          setHouseholdNumber('');
          setIntervieweeName('');
          setIntervieweeRemarks('');
          setVisitingReason('');
          setPeopleNumber(1);
          setVisitorPhoto(null);
          setAddVisitorDialog(false);
        }}
      >
        <div>
          <h3>新增訪客預約及登記</h3>
          <Button
            type="secondary"
            onClick={() => {
              setWebcamDialog(true);
              getWebcam();
            }}
          >
            開啟訪客拍照
          </Button>
          <img
            className={styles.photo}
            src={
              visitorPhoto
                ? visitorPhoto
                : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
            }
            alt="訪客照片"
          ></img>
          <Dialog
            hasMask
            className={styles.dialog}
            visible={webcamDialog}
            footerActions={['ok']}
            onOk={() => {
              setWebcamDialog(false);
            }}
            onCancel={() => {
              setWebcamDialog(false);
            }}
            onClose={() => {
              setWebcamDialog(false);
            }}
          >
            <div className={styles.selectBox}>
              <Select
                defaultValue="請選擇攝影機"
                dataSource={devices}
                onChange={(value, actionType, item) => {
                  console.log(
                    'value:' + value.deviceId,
                    'item:' + item.label,
                    'actionType:' + actionType
                  );
                  setDevicesVal(item.label);
                  let foundDevicesArr = [];
                  let foundDevicesResult = devices.find(
                    ({ label }) => label === devicesVal
                  );
                  foundDevicesArr.push(foundDevicesResult);
                }}
              ></Select>

              <Button
                disabled={!devicesVal ? true : false}
                className={styles.takePitcher}
                type="normal"
                onClick={capture}
              >
                拍照
              </Button>
            </div>
            <div>
              {devicesVal
                ? foundDevicesArr.map((device, index) => {
                    return (
                      <div key={index}>
                        <Webcam
                          audio={false}
                          mirrore="true"
                          height={220}
                          ref={webcamRef}
                          screenshotFormat="image/jpeg"
                          videoConstraints={{ deviceId: device.deviceId }}
                        />
                      </div>
                    );
                  })
                : ''}
            </div>
            <div>{visitorPhoto && <img src={visitorPhoto} />}</div>
          </Dialog>

          <Form>
            <Form.Item required requiredMessage="必填" label="訪客姓名">
              <Input
                aria-required="true"
                name="visitorsName"
                placeholder="請輸入姓名"
                onChange={(value) => {
                  setVisitorsName(value);
                }}
              />
            </Form.Item>
            <Form.Item label="訪客電話">
              <Input
                name="Phone"
                placeholder="請輸入電話號碼"
                onChange={(value) => {
                  setVisitorsPhone(value);
                }}
              />
            </Form.Item>
            <Form.Item label="戶號">
              <div className={styles.householdNumberBox}>
                <CascaderSelect
                  disabled={intervieweeName ? true : false}
                  name="householdNumber"
                  placeholder="請選擇戶號"
                  dataSource={dataSource}
                  onChange={(value, data, extra) => {
                    // console.log(value)

                    residentAccountNumbers
                      .find({ query: { householdNumber: value } })
                      .then((res) => {
                        console.log(
                          '==residentAccountNumbers find householdNumber success:',
                          res.data[0].userName
                        );
                        setHouseholdNumber(value);
                        setResidentName(res.data[0].userName);
                      })
                      .catch((error) => {
                        console.log(
                          '==residentAccountNumbers find householdNumber:',
                          error
                        );
                      });
                  }}
                ></CascaderSelect>
                <h3>{residentName}</h3>
              </div>
            </Form.Item>
            <Form.Item label="受訪人姓名">
              <Input
                disabled={residentName ? true : false}
                name="intervieweeName"
                placeholder="請輸入姓名"
                onChange={(value) => {
                  setIntervieweeName(value);
                }}
              />
            </Form.Item>
            <Form.Item label="備註">
              <Input
                name="intervieweeRemarks"
                placeholder="請輸入受訪人資訊"
                onChange={(value) => {
                  setIntervieweeRemarks(value);
                }}
              />
            </Form.Item>

            <Form.Item label="拜訪時間">
              <h5>預約時間</h5>
              <DatePicker
                name="reservationTimeStart"
                showTime
                onChange={(value) => {
                  setReservationTimeStart(
                    moment(value).format('YYYY-MM-DD HH:MM:SS')
                  );
                }}
              />
              <h5>結束時間</h5>
              <DatePicker
                name="reservationTimeEnd"
                showTime
                onChange={(value) => {
                  setReservationTimeEnd(
                    moment(value).format('YYYY-MM-DD HH:MM:SS')
                  );
                }}
              />
            </Form.Item>
            <Form.Item label="人數">
              <Input
                value={peopleNumber}
                name="peopleNumber"
                placeholder="請輸入人數"
                onChange={(value) => {
                  setPeopleNumber(value);
                }}
              />
            </Form.Item>
            <Form.Item label="拜訪原因">
              <Input.TextArea
                name="content"
                placeholder="請輸入內容"
                maxLength={100}
                rows={4}
                hasLimitHint
                aria-label="input max length 100"
                onChange={(value) => {
                  setVisitingReason(value);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      </Dialog>
      {/* 入場 */}
      <h1>今日尚未離開訪客有{visitorFindEnter.length}人</h1>
      <Table
        dataSource={
          searchVisitorsCardNumber
            ? serachVisitorApproachArr
            : visitorApproachStatusArr
        }
      >
        <Table.Column title="編號" dataIndex="order" width={50} />
        <Table.Column
          title="預約代號"
          dataIndex="appointmentCode"
          width={150}
        />
        <Table.Column title="訪客卡號" dataIndex="cardNumber" width={150} />
        <Table.Column title="來訪時間" dataIndex="admissionTime" width={150} />
        <Table.Column title="訪客姓名" dataIndex="visitorsName" width={150} />
        <Table.Column title="訪客電話" dataIndex="visitorsPhone" width={100} />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column title="此戶號姓名" dataIndex="residentName" width={100} />
        <Table.Column
          title="受訪人姓名"
          dataIndex="intervieweeName"
          width={100}
        />
        <Table.Column title="備註" dataIndex="intervieweeRemarks" width={100} />
        <Table.Column title="拜訪原因" dataIndex="visitingReason" width={150} />
        <Table.Column title="人數" dataIndex="peopleNumber" width={50} />
        <Table.Column
          title="照片"
          width={100}
          dataIndex="visitorPhoto"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);

            return (
              <>
                {record ? (
                  <img
                    className={styles.visitorPhoto}
                    src={
                      visitorApproachStatusArr[index]['visitorPhoto']
                        ? visitorApproachStatusArr[index]['visitorPhoto']
                        : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
                    }
                    alt="訪客照片"
                  />
                ) : (
                  ''
                )}
              </>
            );
          }}
        />

        <Table.Column title="訪客狀態" dataIndex="visitorsStatus" width={100} />
        <Table.Column
          title="訪客卡狀態"
          dataIndex="takeCardStatus"
          width={100}
        />
        <Table.Column
          title="是否遺失訪客卡"
          dataIndex="takeCardLost"
          width={100}
        />
        <Table.Column
          title="操作"
          width={250}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            return (
              <div>
                {/* 離場 */}
                <Button
                  className={styles.buttonEdit}
                  type="secondary"
                  onClick={() => {
                    setVisitorsStatus(
                      visitorApproachStatusArr[index].visitorsStatus
                    );
                    setCardNumber(visitorApproachStatusArr[index].cardNumber);
                    // setCardStatus(cardArr[0].cardStatus);
                    setLeaveIndex(index);
                    setLeaveDialog(true);
                    serverCardDataUpdate();
                  }}
                >
                  離場
                </Button>
                <Dialog
                  hasMask
                  className={styles.dialog}
                  visible={leaveDialog}
                  footerActions={['ok']}
                  onOk={() => {
                    setVisitorsStatus('預約中');
                    setCardNumber('');
                    let cardItem = cardArr[0];
                    // console.log(cardItem)
                    cardItem.cardStatus = '未使用';
                    let item = visitorApproachStatusArr[leaveIndex];
                    item.takeCardStatus = '已還卡';
                    item.visitorsStatus = '已離場';
                    item.leaveTime = moment(new Date()).format(
                      'YYYY-MM-DD HH:mm:ss'
                    );
                    funUpdateVisitor(item._id, item).then(() => {
                      serverVisitorDataUpdate();
                    });
                    funUpdateCard(cardItem._id, cardItem).then(() => {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '離開成功',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      serverCardDataUpdate();
                      setLeaveDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setVisitorsStatus('');
                    setCardNumber('');
                    setLeaveDialog(false);
                  }}
                  onClose={() => {
                    setVisitorsStatus('');
                    setCardNumber('');
                    setLeaveDialog(false);
                  }}
                >
                  <h2>請確認訪客還卡!!</h2>
                </Dialog>
                {/* 刪除 */}
                <Button
                  className={styles.buttonDelete}
                  type="primary"
                  warning
                  onClick={() => {
                    let item = visitorApproachStatusArr[index];
                    funRemoveVisitor(item._id).then(() => {
                      removeItem();
                    });
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }}
        ></Table.Column>
      </Table>
      {/* 預約中 */}
      <h1>訪客預約清單</h1>
      <Table
        dataSource={
          searchVisitorsCardNumber
            ? serachVisitorAppointmentArr
            : visitorAppointmentStatusArr
        }
      >
        <Table.Column title="編號" dataIndex="order" width={50} />
        <Table.Column title="預約代號" dataIndex="appointmentCode" width={80} />
        <Table.Column title="訪客卡號" dataIndex="cardNumber" width={150} />
        <Table.Column
          title="預約時間"
          dataIndex="reservationTimeStart"
          width={100}
        />
        <Table.Column
          title="結束時間"
          dataIndex="reservationTimeEnd"
          width={100}
        />
        <Table.Column title="訪客姓名" dataIndex="visitorsName" width={100} />
        <Table.Column title="訪客電話" dataIndex="visitorsPhone" width={100} />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column title="此戶號姓名" dataIndex="residentName" width={100} />
        <Table.Column
          title="受訪人姓名"
          dataIndex="intervieweeName"
          width={100}
        />
        <Table.Column title="備註" dataIndex="intervieweeRemarks" width={100} />
        <Table.Column title="拜訪原因" dataIndex="visitingReason" width={100} />
        <Table.Column title="人數" dataIndex="peopleNumber" width={50} />
        <Table.Column
          title="照片"
          width={100}
          dataIndex="visitorPhoto"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);

            return (
              <>
                {record ? (
                  <img
                    className={styles.visitorPhoto}
                    src={
                      visitorAppointmentStatusArr[index]['visitorPhoto']
                        ? visitorAppointmentStatusArr[index]['visitorPhoto']
                        : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
                    }
                    alt="訪客照片"
                  />
                ) : (
                  ''
                )}
              </>
            );
          }}
        />

        <Table.Column title="訪客狀態" dataIndex="visitorsStatus" width={100} />
        <Table.Column
          title="訪客卡狀態"
          dataIndex="takeCardStatus"
          width={100}
        />
        <Table.Column
          title="是否遺失訪客卡"
          dataIndex="takeCardLost"
          width={100}
        />
        <Table.Column
          title="操作"
          width={450}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            return (
              <div>
                <Button
                  // disabled={
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已取消' ||
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已離場'
                  //     ? true
                  //     : false
                  // }
                  // className={styles.buttonEdit}
                  type="normal"
                  onClick={() => {
                    setReservationTimeStart(
                      visitorAppointmentStatusArr[index].reservationTimeStart
                    );
                    setReservationTimeEnd(
                      visitorAppointmentStatusArr[index].reservationTimeEnd
                    );
                    setVisitorsName(
                      visitorAppointmentStatusArr[index].visitorsName
                    );
                    setVisitorsPhone(
                      visitorAppointmentStatusArr[index].visitorsPhone
                    );
                    setHouseholdNumber(
                      visitorAppointmentStatusArr[index].householdNumber
                    );
                    setIntervieweeName(
                      visitorAppointmentStatusArr[index].intervieweeName
                    );
                    setIntervieweeRemarks(
                      visitorAppointmentStatusArr[index].intervieweeRemarks
                    );
                    setVisitingReason(
                      visitorAppointmentStatusArr[index].visitingReason
                    );
                    setPeopleNumber(
                      visitorAppointmentStatusArr[index].peopleNumber
                    );
                    setVisitorPhoto(
                      visitorAppointmentStatusArr[index].visitorPhoto
                    );
                    setEditVisitorIndex(index);
                    setEditVisitorDialog(true);
                  }}
                >
                  編輯
                </Button>
                <Dialog
                  hasMask
                  className={styles.dialog}
                  visible={editVisitorDialog}
                  onOk={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setVisitorsPhone('');
                    setHouseholdNumber('');
                    setIntervieweeName('');
                    setIntervieweeRemarks('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setVisitorPhoto('');
                    let item = visitorAppointmentStatusArr[editVisitorIndex];
                    item.reservationTimeStart = reservationTimeStart;
                    item.reservationTimeEnd = reservationTimeEnd;
                    item.visitorsName = visitorsName;
                    item.visitorsPhone = visitorsPhone;
                    item.householdNumber = householdNumber;
                    item.intervieweeName = intervieweeName;
                    item.residentName = residentName;
                    item.intervieweeRemarks = intervieweeRemarks;
                    item.visitingReason = visitingReason;
                    item.peopleNumber = peopleNumber;
                    item.visitorPhoto = visitorPhoto;
                    item.updatedTime = moment(new Date()).format(
                      'YYYY-MM-DD HH:mm:ss'
                    );
                    funUpdateVisitor(item._id, item).then(() => {
                      serverVisitorDataUpdate();
                      setEditVisitorDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setVisitorsPhone('');
                    setHouseholdNumber('');
                    setIntervieweeName('');
                    setIntervieweeRemarks('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setVisitorPhoto('');
                    setEditVisitorDialog(false);
                  }}
                  onClose={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setVisitorsPhone('');
                    setHouseholdNumber('');
                    setIntervieweeName('');
                    setIntervieweeRemarks('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setVisitorPhoto('');
                    setEditVisitorDialog(false);
                  }}
                >
                  <h3>編輯訪客預約及登記</h3>
                  <Button
                    type="secondary"
                    onClick={() => {
                      setWebcamEditDialog(true);
                    }}
                  >
                    編輯訪客照片
                  </Button>
                  <Dialog
                    hasMask
                    className={styles.dialog}
                    visible={webcamEditDialog}
                    footerActions={['ok']}
                    onOk={() => {
                      setWebcamEditDialog(false);
                    }}
                    onCancel={() => {
                      setWebcamEditDialog(false);
                    }}
                    onClose={() => {
                      setWebcamEditDialog(false);
                    }}
                  >
                    <div className={styles.selectBox}>
                      <Select
                        defaultValue="請選擇攝影機"
                        dataSource={devices}
                        onChange={(value, actionType, item) => {
                          // console.log("value:"+value.deviceId,"item:"+item.label,"actionType:"+actionType)
                          setDevicesVal(item.label);
                          let foundDevicesArr = [];
                          let foundDevicesResult = devices.find(
                            ({ label }) => label === devicesVal
                          );
                          foundDevicesArr.push(foundDevicesResult);
                        }}
                      ></Select>

                      <Button
                        disabled={!devicesVal ? true : false}
                        className={styles.takePitcher}
                        type="normal"
                        onClick={capture}
                      >
                        拍照
                      </Button>
                    </div>
                    <div>
                      {devicesVal
                        ? foundDevicesArr.map((device, index) => {
                            return (
                              <div key={index}>
                                <Webcam
                                  audio={false}
                                  mirrore="true"
                                  height={220}
                                  ref={webcamRef}
                                  screenshotFormat="image/jpeg"
                                  videoConstraints={{
                                    deviceId: device.deviceId,
                                  }}
                                />
                              </div>
                            );
                          })
                        : ''}
                    </div>
                    <div>{visitorPhoto && <img src={visitorPhoto} />}</div>
                  </Dialog>

                  <img
                    className={styles.photo}
                    src={
                      visitorPhoto
                        ? visitorPhoto
                        : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
                    }
                    alt="訪客照片"
                  ></img>
                  <Form.Item label="訪客姓名">
                    <Input
                      name="visitorsName"
                      placeholder="請輸入姓名"
                      value={visitorsName}
                      onChange={(value) => {
                        setVisitorsName(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="訪客電話">
                    <Input
                      name="visitorsPhone"
                      placeholder="請輸入電話號碼"
                      value={visitorsPhone}
                      onChange={(value) => {
                        setVisitorsPhone(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="戶號">
                    <div className={styles.householdNumberBox}>
                      <CascaderSelect
                        disabled={intervieweeName ? true : false}
                        placeholder="請選擇戶號"
                        value={householdNumber}
                        dataSource={dataSource}
                        onChange={(value, data, extra) => {
                          residentAccountNumbers
                            .find({ query: { householdNumber: value } })
                            .then((res) => {
                              console.log(
                                '==residentAccountNumbers find householdNumber success:',
                                res.data[0].userName
                              );
                              setHouseholdNumber(value);
                              setResidentName(res.data[0].userName);
                            })
                            .catch((error) => {
                              console.log(
                                '==residentAccountNumbers find householdNumber:',
                                error
                              );
                            });
                        }}
                      ></CascaderSelect>
                      <h3>{residentName}</h3>
                    </div>
                  </Form.Item>
                  <Form.Item label="受訪人姓名">
                    <Input
                      disabled={residentName ? true : false}
                      value={intervieweeName}
                      name="intervieweeName"
                      placeholder="請輸入姓名"
                      onChange={(value) => {
                        setIntervieweeName(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="備註">
                    <Input
                      value={intervieweeRemarks}
                      name="intervieweeRemarks"
                      placeholder="請輸入受訪人資訊"
                      onChange={(value) => {
                        setIntervieweeRemarks(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="預計拜訪時間">
                    <h5>預約時間</h5>
                    <DatePicker
                      showTime
                      value={reservationTimeStart}
                      onChange={(value) => {
                        setReservationTimeStart(
                          moment(value).format('YYYY-MM-DD HH:MM:SS')
                        );
                      }}
                    />
                    <h5>預約時間</h5>
                    <DatePicker
                      showTime
                      value={reservationTimeEnd}
                      onChange={(value) => {
                        setReservationTimeEnd(
                          moment(value).format('YYYY-MM-DD HH:MM:SS')
                        );
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="人數">
                    <Input
                      value={peopleNumber}
                      name="peopleNumber"
                      placeholder="請輸入人數"
                      onChange={(value) => {
                        setPeopleNumber(value);
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="拜訪原因">
                    <Input.TextArea
                      value={visitingReason}
                      name="content"
                      placeholder="請輸入內容"
                      maxLength={100}
                      rows={4}
                      hasLimitHint
                      aria-label="input max length 100"
                      onChange={(value) => {
                        setVisitingReason(value);
                      }}
                    />
                  </Form.Item>
                </Dialog>

                {/* 取消預約 */}
                <Button
                  // disabled={
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已取消' ||
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已離場'
                  //     ? true
                  //     : false
                  // }
                  className={styles.buttonEdit}
                  type="secondary"
                  onClick={() => {
                    setVisitorsStatus(
                      visitorAppointmentStatusArr[index].visitorsStatus
                    );
                    setCancleIndex(index);
                    setCancleDialog(true);
                  }}
                >
                  取消
                </Button>
                <Dialog
                  hasMask
                  className={styles.dialog}
                  visible={cancleDialog}
                  footerActions={['ok']}
                  onOk={() => {
                    let item = visitorAppointmentStatusArr[cancleIndex];

                    item.visitorsStatus = '已取消';
                    item.cancleTime = moment(new Date()).format(
                      'YYYY-MM-DD HH:mm:ss'
                    );
                    funUpdateVisitor(item._id, item).then(() => {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '取消成功',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      serverVisitorDataUpdate();
                      setCancleDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setCancleDialog(false);
                  }}
                  onClose={() => {
                    setCancleDialog(false);
                  }}
                >
                  <h2>確定取消預約</h2>
                </Dialog>

                {/* 取卡 */}
                <Button
                  // disabled={
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已入場' ||
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已取消' ||
                  //   visitorAppointmentStatusArr[index].visitorsStatus === '已離場'
                  //     ? true
                  //     : false
                  // }
                  className={styles.buttonEdit}
                  type="primary"
                  onClick={() => {
                    setReservationTimeStart(
                      visitorAppointmentStatusArr[index].reservationTimeStart
                    );
                    setReservationTimeEnd(
                      visitorAppointmentStatusArr[index].reservationTimeEnd
                    );
                    setVisitorsName(
                      visitorAppointmentStatusArr[index].visitorsName
                    );
                    setHouseholdNumber(
                      visitorAppointmentStatusArr[index].householdNumber
                    );
                    setVisitingReason(
                      visitorAppointmentStatusArr[index].visitingReason
                    );
                    setPeopleNumber(
                      visitorAppointmentStatusArr[index].peopleNumber
                    );
                    setVisitorsStatus(
                      visitorAppointmentStatusArr[index].visitorsStatus
                    );
                    setTakeCardIndex(index);
                    setTakeCardDialog(true);
                    serverCardAllDataUpdate();
                  }}
                >
                  取卡
                </Button>

                <Dialog
                  hasMask
                  className={styles.dialog}
                  visible={takeCardDialog}
                  footerActions={['ok']}
                  onOk={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setHouseholdNumber('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setCardNumber('');
                    let cardItem = cardArr[0];
                    cardItem.cardStatus = '使用中';
                    let item = visitorAppointmentStatusArr[takeCardIndex];
                    item.takeCardStatus = '已領卡';
                    item.visitorsStatus = '已入場';
                    item.cardNumber = cardArr[0].cardNumber;
                    item.admissionTime = moment(new Date()).format(
                      'YYYY-MM-DD HH:mm:ss'
                    );
                    funUpdateVisitor(item._id, item).then(() => {
                      serverVisitorDataUpdate();
                    });
                    funUpdateCard(cardItem._id, cardItem).then(() => {
                      Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: '領取成功',
                        showConfirmButton: false,
                        timer: 1500,
                      });
                      serverCardDataUpdate();
                      setTakeCardDialog(false);
                    });
                  }}
                  onCancel={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setHouseholdNumber('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setCardNumber('');
                    setTakeCardDialog(false);
                  }}
                  onClose={() => {
                    setReservationTimeStart('');
                    setReservationTimeEnd('');
                    setVisitorsName('');
                    setHouseholdNumber('');
                    setVisitingReason('');
                    setPeopleNumber('');
                    setCardNumber('');
                    setTakeCardDialog(false);
                  }}
                >
                  <h3>預約取卡</h3>
                  <Form.Item label="訪客姓名">{visitorsName}</Form.Item>
                  <Form.Item label="戶號">{householdNumber}</Form.Item>
                  <Form.Item label="人數">{peopleNumber}</Form.Item>
                  <Form.Item label="拜訪原因">{visitingReason}</Form.Item>
                  <Form.Item label="訪客卡號">
                    <div className={styles.addCardNumberBox}>
                      <h2>{cardNumber ? cardNumber : '請先請先加入卡號'}</h2>
                      <Button
                        className={styles.addCardNumberBtn}
                        type="secondary"
                        onClick={() => {
                          setScanCardDialog(true);
                        }}
                      >
                        加入卡號
                      </Button>
                    </div>
                    <Dialog
                      hasMask
                      className={styles.scanCardDialog}
                      visible={scanCardDialog}
                      footer={false}
                      onClose={() => {
                        setScanCardDialog(false);
                      }}
                    >
                      <div>
                        <BarcodeReader
                          onScan={(data) => {
                            let foundData = cardAllArr.find(
                              (element) => element.cardNumber === data
                            );
                            // console.log(foundData)
                            try {
                              if (foundData.cardStatus === '使用中') {
                                Message.error('此卡號正在使用中');
                              } else {
                                setCardNumber(data);
                                setScanCardDialog(false);
                              }
                            } catch (e) {
                              // console.log(e)
                              Message.error('查無此卡片');
                            }
                          }}
                          onError={(err) => {
                            console.error(err);
                          }}
                        />
                        <Input
                          placeholder="自行輸入卡片編號 Enter確認"
                          value={cardNumber}
                          onChange={(value) => {
                            setCardNumber(value);
                          }}
                          onPressEnter={() => {
                            let foundData = cardAllArr.find(
                              (element) => element.cardNumber === cardNumber
                            );
                            try {
                              if (foundData.cardStatus === '使用中') {
                                Message.error('此卡號正在使用中');
                              } else {
                                setScanCardDialog(false);
                              }
                            } catch (e) {
                              // console.log(e)
                              Message.error('查無此卡片');
                            }
                          }}
                        ></Input>

                        <br />
                        <br />
                        <img
                          src="https://i.ibb.co/h8yWyPd/image0.jpg"
                          alt="cardImg"
                          type="cover"
                          width={400}
                          height={300}
                        ></img>

                        <h1>請掃描卡片...</h1>
                      </div>
                    </Dialog>
                  </Form.Item>
                </Dialog>

                {/* 刪除 */}
                <Button
                  className={styles.buttonDelete}
                  type="primary"
                  warning
                  onClick={() => {
                    let item = visitorAppointmentStatusArr[index];
                    funRemoveVisitor(item._id).then(() => {
                      removeItem();
                    });
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }}
        ></Table.Column>
      </Table>
      {/* <Pagination
          className="custom-pagination"
          pageSizeSelector="dropdown"
          pageSizePosition="start"
          pageSize={5}
          pageShowCount={3}
          showJump={true}
          total={visitorAppointmentStatusArr.length}
          totalRender={total => `Total: ${total}`}
          onChange={pageNumberOnChange}
          total={pagination.allAudits.length}
          current={pagination.currentPage}


        /> */}
      <h1>今日離開的訪客有{visitorFindLeave.length}人</h1>
      <Table
        dataSource={
          searchVisitorsCardNumber
            ? serachVisitorLeaveArr
            : visitorLeaveStatusArr
        }
      >
        <Table.Column title="編號" dataIndex="order" width={50} />
        <Table.Column
          title="預約代號"
          dataIndex="appointmentCode"
          width={150}
        />
        <Table.Column title="訪客卡號" dataIndex={'cardNumber'} width={150} />
        <Table.Column title="來訪時間" dataIndex="admissionTime" width={150} />
        <Table.Column title="離開時間" dataIndex="leaveTime" width={150} />
        <Table.Column title="訪客姓名" dataIndex="visitorsName" width={100} />
        <Table.Column title="訪客電話" dataIndex="visitorsPhone" width={100} />
        <Table.Column title="戶號" dataIndex="householdNumber" width={100} />
        <Table.Column title="此戶號姓名" dataIndex="residentName" width={100} />
        <Table.Column
          title="受訪人姓名"
          dataIndex="intervieweeName"
          width={150}
        />
        <Table.Column title="備註" dataIndex="intervieweeRemarks" width={100} />
        <Table.Column title="拜訪原因" dataIndex="visitingReason" width={100} />
        <Table.Column title="人數" dataIndex="peopleNumber" width={50} />
        <Table.Column
          title="照片"
          width={100}
          dataIndex="visitorPhoto"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);

            return (
              <>
                {record ? (
                  <img
                    className={styles.visitorPhoto}
                    src={
                      visitorLeaveStatusArr[index]['visitorPhoto']
                        ? visitorLeaveStatusArr[index]['visitorPhoto']
                        : 'https://i.ibb.co/LZRgfyg/2021-02-01-5-48-52.png'
                    }
                    alt="訪客照片"
                  />
                ) : (
                  ''
                )}
              </>
            );
          }}
        />

        <Table.Column title="訪客狀態" dataIndex="visitorsStatus" width={100} />
        <Table.Column
          title="訪客卡狀態"
          dataIndex="takeCardStatus"
          width={100}
        />
        <Table.Column
          title="是否遺失訪客卡"
          dataIndex="takeCardLost"
          width={100}
        />
        <Table.Column
          title="操作"
          width={250}
          lock="right"
          cell={(value, index, record) => {
            // console.log('==op ', value, index, record);
            return (
              <div>
                {/* 刪除 */}
                <Button
                  className={styles.buttonDelete}
                  type="primary"
                  warning
                  onClick={() => {
                    let item = visitorLeaveStatusArr[index];
                    funRemoveVisitor(item._id).then(() => {
                      removeItem();
                    });
                  }}
                >
                  刪除
                </Button>
              </div>
            );
          }}
        ></Table.Column>
      </Table>
    </>
  );
};

export default VisitorAppointmentRegistrationList;
